import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

const dismissedTipsStore = create<State>()(
  persist(
    (set) => ({
      dismissedTipsIds: [],
      addOne: (id: string) =>
        set((state) => ({
          ...state,
          dismissedTipsIds: [...state.dismissedTipsIds, id],
        })),
    }),
    {
      name: "dismissed-tips-storage",
      storage: createJSONStorage(() => localStorage),
    }
  )
);

interface State {
  dismissedTipsIds: string[];
  addOne: (id: string) => void;
}

export default dismissedTipsStore;
